import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, ArrowRight, Award } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { LAB_PATH, LABS_LIST, fetchLabs } from "@/lib/aiot";

const BRIEF = {
  home: ["9 devices · 8 scenarios: dark arrival, summer heat, LPG leak, smoke, intruder", "9 डिवाइस · 8 सीनारियो: अँधेरे में आना, गर्मी, LPG लीक, धुआँ, घुसपैठ"],
  hotel: ["8 devices · 7 scenarios: key-card check-in, empty room, door left open, smoke, night", "8 डिवाइस · 7 सीनारियो: की-कार्ड चेक-इन, खाली कमरा, खुला दरवाज़ा, धुआँ, रात"],
  factory: ["8 devices · 8 scenarios: shift start, light curtain, E-stop, overheating, vibration, jam", "8 डिवाइस · 8 सीनारियो: शिफ़्ट शुरू, लाइट कर्टेन, E-स्टॉप, ओवरहीट, वाइब्रेशन, जाम"],
};

export const LabsOverview = ({ enrolled }) => {
  const { L } = useLang();
  const [rows, setRows] = useState({});
  useEffect(() => { if (enrolled) fetchLabs().then((d) => setRows(Object.fromEntries(d.items.map((x) => [x.id, x])))).catch(() => {}); }, [enrolled]);
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8" data-testid="aiot-labs-overview">
      <h2 className="text-2xl font-extrabold text-[#0B1F3A]">{L("3D automation labs", "3D ऑटोमेशन लैब")}</h2>
      <p className="mt-1 text-sm text-slate-600">{L("Place, wire and program every device, then test it in 3D. The average of all 3 labs is 30% of your result. A perfect 100/100 earns a verifiable certificate.", "हर डिवाइस लगाइए, वायर कीजिए, प्रोग्राम कीजिए और 3D में टेस्ट कीजिए। तीनों लैब का औसत आपके रिज़ल्ट का 30% है। 100/100 पर सत्यापित प्रमाणपत्र मिलता है।")}</p>
      <div className="mt-6 grid md:grid-cols-3 gap-4">
        {LABS_LIST.map(([k, en, hi]) => {
          const r = rows[k];
          return (
            <Link key={k} to={LAB_PATH(k)} className="group rounded-2xl border border-slate-200 p-5 hover:border-[#14B8A6] hover:bg-[#F0FDFA] transition-colors flex flex-col" data-testid={`aiot-labs-card-${k}`}>
              <span className="w-10 h-10 rounded-xl bg-[#0B1F3A] text-[#5EEAD4] grid place-items-center"><Box className="w-5 h-5" /></span>
              <span className="mt-3 font-extrabold text-[#0B1F3A]">{L(en, hi)}</span>
              <span className="mt-1 text-xs text-slate-600 flex-1">{L(...BRIEF[k])}</span>
              <span className="mt-3 text-xs font-bold text-slate-500" data-testid={`aiot-labs-score-${k}`}>
                {!enrolled ? L("Practice mode", "प्रैक्टिस मोड") : r?.score != null ? L(`Best ${r.score}/100 · ${r.attempts} runs`, `सबसे अच्छा ${r.score}/100 · ${r.attempts} रन`) : L("Not attempted yet", "अभी नहीं किया")}
              </span>
              {r?.cert_no && <span className="mt-2 inline-flex items-center gap-1 text-xs font-black text-[#0F766E]" data-testid={`aiot-labs-cert-${k}`}><Award className="w-3.5 h-3.5" />{r.cert_no}</span>}
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-[#0F766E] group-hover:gap-2 transition-[gap]">{L("Open lab", "लैब खोलें")}<ArrowRight className="w-4 h-4" /></span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
